import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import LabelListItem from "../LabelListItem";
import { formatGermanNumber } from "../../formatterHelpers";
import { UmsatzmengenAuswertung } from "../../api";

interface BaustellenMaterialCardProps {
  title: string;
  konto?: UmsatzmengenAuswertung;
}

export default function BaustellenMaterialCard({
  title,
  konto,
}: BaustellenMaterialCardProps) {
  return (
    <Card>
      <Typography sx={{ ml: 2, mt: 2 }}>{title}</Typography>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <LabelListItem label={"Eigene Fuhren"}>
              {formatGermanNumber(konto?.eigeneFuhren, 0)}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Eigene Kubikm"}>
              {formatGermanNumber(konto?.eigeneKubikmeter, 2)}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Eigene Tonnen"}>
              {formatGermanNumber(konto?.eigeneTonne, 2)}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Eigene Stück"}>
              {formatGermanNumber(konto?.eigeneStueck, 0)}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Fremde Fuhren"}>
              {formatGermanNumber(konto?.fremdeFuhren, 0)}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Fremde Kubikm"}>
              {formatGermanNumber(konto?.fremdeKubikmeter, 2)}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Fremde Tonnen"}>
              {formatGermanNumber(konto?.fremdeTonne, 2)}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Fremde Stück"}>
              {formatGermanNumber(konto?.fremdeStueck, 0)}
            </LabelListItem>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Gesamte Fuhren"}>
              {formatGermanNumber(
                (konto?.eigeneFuhren ?? 0) + (konto?.fremdeFuhren ?? 0),
                0
              )}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Kubikmeter gesamt"}>
              {formatGermanNumber(
                (konto?.eigeneKubikmeter ?? 0) + (konto?.fremdeKubikmeter ?? 0),
                2
              )}
            </LabelListItem>
          </Grid>

          <Grid item xs={3}>
            <LabelListItem label={"Gesamt Tonnen"}>
              {formatGermanNumber(
                (konto?.eigeneTonne ?? 0) + (konto?.fremdeTonne ?? 0),
                2
              )}
            </LabelListItem>
          </Grid>
          <Grid item xs={3}>
            <LabelListItem label={"Gesamt Stück"}>
              {formatGermanNumber(
                (konto?.eigeneStueck ?? 0) + (konto?.fremdeStueck ?? 0),
                0
              )}
            </LabelListItem>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
